
import { Component, Vue } from "vue-property-decorator";
import { customerOrderService } from "@/services/api/customerOrder.service";
import moment from "moment";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import OverlayModule from "@/store/modules/core/overlay.module";
import AuthModule from "@/store/modules/core/auth.module";
const authModule = getModule(AuthModule, store);
const overlayModule = getModule(OverlayModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const LoadingOverlay = () => import("@/components/core/LoadingOverlay.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    LoadingOverlay,
    MessageDialog,
  },
})
export default class Orders extends Vue {
  // VARS --- COMPONENTS
  private numberSelected = 0;
  private messageDialogOpen = false;
  private dialogText = "";
  private loadingOverlayOpen = false;
  private isLoadingButton = false;

  private selectedOrder = {
    orderId: 0,
    orderDate: "",
    OrderDetails: [],
    orderAmount: 0,
    notes: "",
    kits: 0,
    purchaseDateView: Date.now(),
    codiceCliente: "",
    ragioneSociale: "",
  };

  // METHODS --- INIT
  private beforeMount(): void {
    if (!this.$route.query.idOrder) {
      this.wrongRouteRedirect();
    }

    this.selectedOrder.orderId = parseInt(this.$route.query.idOrder.toString());
    if (!this.selectedOrder.orderId) {
      this.wrongRouteRedirect();
    }

    customerOrderService
      .checkCustomerOrderAccess(this.selectedOrder.orderId, authModule.userName)
      .then((resCheck) => {
        if (resCheck.data) {
          this.getOrderDetails();
        } else {
          this.wrongRouteRedirect();
        }
      })
      .catch((e) => {
        console.warn(e);
        this.wrongRouteRedirect();
      });
  }
  private wrongRouteRedirect(): void {
    this.$router.push("/");
  }

  // VARS --- TABLE
  private selectedOrderTable = {
    isLoading: false,
    headers: [
      { text: "Codice", value: "productID" },
      {
        text: "Categoria",
        align: "start",
        filterable: true,
        value: "catDescr",
      },
      { text: "Descrizione", value: "description" },
      { text: "Chiavi Ricerca", value: "keywords" },
      { text: "Marca", value: "brand" },
      { text: "Modello Auto", value: "model" },
      { text: "Anno", value: "fromYear" },
      { text: "Tipo", value: "carType" },
      { text: "Canale", value: "artCanale" },
      { text: "Diam.", value: "diameter" },
      { text: "Fori", value: "artFori" },
      { text: "Pcd", value: "artPcd" },
      { text: "Foro centr.", value: "artForoCentrale" },
      { text: "Et", value: "artEt" },
      { text: "Peso", value: "peso" },
      { text: "Qty", value: "quantity" },
      { text: "P.N.", value: "price" },
      { text: "Tot.", value: "price" },
    ],
    set: [],
    search: "",
  };

  // METHODS --- ORDER DETAILS MODAL
  private getOrderDetails(): void {
    this.loadingOverlayOpen = true;
    overlayModule.showOverlay();
    let orderId = this.selectedOrder.orderId;

    customerOrderService
      .checkOrderSingle(orderId)
      .then((resSingle) => {
        this.selectedOrder.codiceCliente = resSingle.data.codiceCliente;
        this.selectedOrder.orderId = resSingle.data.orderID;
        this.selectedOrder.orderDate = resSingle.data.orderDate;
        this.selectedOrder.ragioneSociale = resSingle.data.ragioneSociale;
        this.selectedOrder.notes = resSingle.data.notes;

        customerOrderService.getOrderKitsByID(orderId).then((resKits) => {
          this.selectedOrder.kits = resKits.data;
          customerOrderService.getOrderByID(orderId).then((res) => {
            this.loadingOverlayOpen = false;
            if (res.status === 200) {
              this.selectedOrder.OrderDetails = res.data;
              this.selectedOrderTable.set = res.data;
              overlayModule.hideOverlay();
              this.selectedOrder.orderAmount = resKits.data * 14;
              res.data.forEach((dataItem: any) => {
                this.selectedOrder.orderAmount +=
                  dataItem.price * dataItem.quantity;
              });
            } else {
              errorHandling();
            }
          });
        });
      })
      .catch((e) => {
        errorHandling(e);
      });

    let errorHandling = (e = ""): void => {
      console.warn(e);
      this.loadingOverlayOpen = false;
      this.messageDialogOpen = true;
      this.dialogText = "Non è stato possibile recuperare i dati degli ordini!";
      overlayModule.hideOverlay();
    };
  }

  // METHODS --- PRINT DETAILS ACTION
  private exportDetails(): void {
    this.isLoadingButton = true;
    customerOrderService
      .exportCustomerOrder(
        this.selectedOrder.orderId,
        this.selectedOrder.codiceCliente,
        this.selectedOrder.orderDate,
        this.selectedOrder.ragioneSociale
      )
      .then((res) => {
        if (res.status === 200) {
          if (res.data.isSuccess) {
            let downloadLinkEl = document.createElement("a");
            downloadLinkEl.href = res.data.result;
            downloadLinkEl.download = `ordine${this.selectedOrder.orderId}`;
            downloadLinkEl.click();
            downloadLinkEl.remove();
            this.isLoadingButton = false;
          } else {
            errorHandling();
          }
        } else {
          errorHandling();
        }
      })
      .catch((e) => {
        console.warn(e);
        errorHandling();
      });

    let errorHandling = (): void => {
      this.isLoadingButton = false;
      this.messageDialogOpen = true;
      this.dialogText =
        "Non è stato possibile esportare i dati dell'ordine come PDF!";
    };
  }

  // METHODS --- FRONTEND
  private prepDate(date): string {
    return moment(date).format("DD/MM/YYYY HH:mm");
  }
}
